<template>
  <li class="nav-item" :class="{'display_multistruct_li':isOpen}" >
    <b class="icon_struct_li" v-if="!isOpen" @click="toggle" >&#128193;</b>
    <b class="icon_struct_li" v-if="isOpen" @click="toggle" >&#x1F4C2;</b>

    <router-link v-if="current!=item.last_id"  @click="toggle"
                 @dblclick="makeFolder"   :to="{name: 'one_article', params: {id:item.project_id, post_id: item.last_id }}"
    >{{ item.title }}
    </router-link>


      <strong v-if="current==item.last_id"  @click="toggle"
               @dblclick="makeFolder">{{ item.title }}</strong>




    <ul class="multi_struct" v-if="item.childrens.length>0">
    <tree-view
          class="item "
          :class="{'display_multistruct':isOpen}"
          v-if="item.childrens.length>0"
          v-for="(child, index) in item.childrens"
          :key="index"
          :item="child"
          :current="current"
          @add-item="$emit('add-item', $event)"
      ></tree-view>
      <li class="pointer_element"  @click="$emit('add-item', item)">&#x1F4C4; Добавить статью</li>
    </ul>
    <ul class="multi_struct" v-if="item.childrens.length==0">
      <li class="pointer_element"  @click="$emit('add-item', item)">&#x1F4C4; Добавить статью</li>
    </ul>
  </li>
</template>

<script>
export default {
  name: "TreeView",
  props: {
    item: Object,
    current:Number,
  },
  data: function() {
    return {
      isOpen: false
    };
  },
  computed: {
    isFolder: function() {

      return this.item.childrens && this.item.childrens.length;
    }
  },
  methods: {
    toggle: function() {
      this.isOpen = !this.isOpen;
    },
    makeFolder: function() {
      if (!this.isFolder) {
        this.$emit("make-folder", this.item);
        this.isOpen = true;
      }
    }
  }
}
</script>

<style scoped>

</style>